// extracted by mini-css-extract-plugin
export default {"productCarousel":"lZ-z"};